/** @graphql cc **/
import gql from 'graphql-tag';
export const RestrictionsDialogQuery = gql`
	query RestrictionsDialogQuery(
		$contentId: ID!
		$status: [String]
		$draftShareId: String
		$readUserStart: Int = 0
		$readGroupStart: Int = 0
		$editUserStart: Int = 0
		$editGroupStart: Int = 0
	) {
		content(id: $contentId, status: $status, draftShareId: $draftShareId) {
			nodes {
				id
				ancestors {
					id
					hasViewRestrictions
					links {
						webui
					}
				}
				hasInheritedRestrictions
				hasRestrictions
				hasViewRestrictions
				title
				type
				status
				subType
				operations {
					operation
					targetType
				}
				restrictions {
					read {
						restrictions {
							userWithRestrictions(start: $readUserStart) {
								count
								nodes {
									type
									displayName
									accountId
									profilePicture {
										path
									}
									hasSpaceViewPermission
									hasSpaceEditPermission
									permissionType
									restrictingContent {
										id
										links {
											webui
											base
										}
									}
								}
								pageInfo {
									hasNextPage
									endCursor
								}
							}
							group(start: $readGroupStart) {
								count
								nodes {
									id
									name
									permissionType
								}
								pageInfo {
									hasNextPage
									endCursor
								}
							}
						}
					}
					update {
						restrictions {
							userWithRestrictions(start: $editUserStart) {
								count
								nodes {
									type
									displayName
									accountId
									profilePicture {
										path
									}
									hasSpaceViewPermission
									hasSpaceEditPermission
									permissionType
									restrictingContent {
										id
										links {
											webui
											base
										}
									}
								}
								pageInfo {
									hasNextPage
									endCursor
								}
							}
							group(start: $editGroupStart) {
								count
								nodes {
									id
									name
									permissionType
								}
								pageInfo {
									hasNextPage
									endCursor
								}
							}
						}
					}
				}
				space {
					id
					containsExternalCollaborators
					externalCollaboratorCount
				}
			}
		}
		user: confluence_atlassianUser(current: true) {
			id
			displayName
			photos {
				value
				isPrimary
			}
		}
		tenant: confluence_tenantContext {
			editions {
				confluence
			}
		}
	}
`;
